<template>
    <div>
        <div class="pt-15 px-4">
            <div class="mt-8">
                <v-card class="px-3 py-3">
                    <v-row class="justify-space-between">
                        <v-col>
                            <p style="color: #4477ad; font-size: 26px">
                                Indicadores
                            </p>
                        </v-col>
                    </v-row>
                    <v-row class="ma-6 pa-2 justify-center">
                        <v-card class="col-5 mr-10 ml-10">
                            <v-row class="justify-space-between">
                                <v-col>
                                    <p style="color: #4477ad; font-size: 26px">
                                        Navegación
                                    </p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-list lines="one">
                                        <v-list-item><v-btn href="#/customers-registrados-logados">Customers Logados X Registrados</v-btn></v-list-item>
                                        <v-list-item><v-btn href="#/paginas-mais-acessadas">Páginas más Visitadas</v-btn></v-list-item>
                                        <v-list-item><v-btn href="#/acessos-customers">Clientes Activos</v-btn></v-list-item>
                                      </v-list>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="col-5 mr-10">
                            <v-row class="justify-space-between">
                                <v-col>
                                    <p style="color: #4477ad; font-size: 26px">
                                        Ventas
                                    </p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-list lines="two">
                                        <v-list-item><v-btn disabled href="#">Facturas</v-btn></v-list-item>
                                        <v-list-item><v-btn disabled href="#">Pedidos</v-btn></v-list-item>
                                      </v-list>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-row>
                </v-card>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    name: 'HomeIndicadores',
    data() {
        return {

        }
    },
    mounted() {
    },
    methods: {
    },
    computed: {
    }
}
</script>
  
<style scoped lang="css"></style>